import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LogsComponent} from '../../SharedModule/LogsComponent/logs.component';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material';
import {DocumentService} from '../../services/document.service';
import {Document} from '../../model/Entities/Document';
import {DocumentTypeService} from '../../services/document-type.service';
import {DOCUMENT_TYPE, DocumentType} from '../../model/Entities/DocumentType';
import {Filter} from '../../model/Helpers/Filter';
import {FormControl, Validators} from '@angular/forms';
import {DocumentCompanyService} from '../../services/document-company.service';
import {DocumentCompany} from '../../model/Entities/DocumentCompany';
import {Customer} from '../../model/Entities/Customer';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import {CustomerService} from '../../services/customer.service';
import {PaymentTypeService} from '../../services/payment-type.service';
import {PaymentTypeEntity} from '../../model/Entities/PaymentType';
import {ContractState} from '../../model/Entities/ContractState';
import {SnackService} from '../../services/snack.service';
import {DocumentCreateDialogComponent} from '../DocumentCreateDialogComponent/document-create.dialog.component';
import {DocumentLiquidationsDialogComponent} from '../DocumentLiquidationsDialogComponent/document-liquidations.dialog.component';
import {DialogService} from '../../services/dialog.service';
import {PrintService} from '../../services/print.service';
import {DocumentItem} from '../../model/Entities/DocumentItem';
import {Vat} from '../../model/Entities/Vat';
import {VatService} from '../../services/vat.service';
import {
    ContractGroupItemLossDialogComponent
} from '../../ContractsModule/ContractGroupItemLossDialogComponent/contract-group-item-loss.dialog.component';
import {Product} from '../../model/Entities/Product';
import {ProductService} from '../../services/product.service';
import {DocumentLinkDialogComponent} from '../DocumentLinkDialogComponent/document-link.dialog.component';
import {DocumentLink} from '../../model/Entities/DocumentLink';
import {ContractService} from '../../services/contract.service';
import {Contract} from '../../model/Entities/Contract';
import {ContractItem} from '../../model/Entities/ContractItem';
import {ContractItemService} from '../../services/contract-item.service';
import {DocumentLinkService} from '../../services/document-link.service';
import {
    ContractStateChangeConfirmDialogComponent
} from '../../ContractsModule/ContractStateChangeConfirmDialogComponent/contract-state-change-confirm.dialog.component';
import {ContractItemTransfer} from '../../model/Entities/ContractItemTransfer';
import {ContractItemType} from '../../model/Entities/ContractItemType';
import {DocumentPohodaDialogComponent} from '../DocumentPohodaDialogComponent/document-pohoda.dialog.component';
import {ContractMailDialogComponent} from '../../ContractsModule/ContractMailDialogComponent/contract-mail.dialog.component';
import {DocumentMailDialogComponent} from '../DocumentMailDialogComponent/document-mail.dialog.component';
import {DocumentLiquidationService} from '../../services/documentLiquidation.service';
import {DocumentLiquidation} from '../../model/Entities/DocumentLiquidation';
import {DocumentCurrencyService} from '../../services/document-currency.service';
import {DocumentCurrency} from '../../model/Entities/DocumentCurrency';
import {CustomerCreateDialogComponent} from '../../CustomersModule/CustomerCreateDialogComponent/customer-create.dialog.component';
import {CustomerAresComparisonDialogComponent} from '../../CustomersModule/CustomerAresComparisonDialogComponent/customer-ares-comparison.dialog.component';
import {DragulaService} from 'ng2-dragula';


@Component({
    selector: 'document-edit',
    templateUrl: './document-edit.component.html',
    styleUrls: ['./document-edit.component.scss']
})
export class DocumentEditComponent implements OnInit, OnDestroy {

    private customerSearchElement: ElementRef;
    private productSearchElement: ElementRef;
    private contractSearchElement: ElementRef;

    private customerSearchSubscription: Subscription;
    private productSearchSubscription: Subscription;
    private contractSearchSubscription: Subscription;

    @ViewChild('customerSearch') set customerSearch(element: ElementRef) {
        if (element) {
            this.customerSearchElement = element;
            this.initCustomerSearchListener();
        }
    }

    @ViewChild('productSearch') set productSearch(element: ElementRef) {
        if (element) {
            this.productSearchElement = element;
            this.initProductSearchListener();
        }
    }

    @ViewChild('contractSearch') set contractSearch(element: ElementRef) {
        if (element) {
            this.contractSearchElement = element;
            this.initContractSearchListener();
        }
    }

    @ViewChild('logsComponent') logsComponent: LogsComponent;
    @ViewChild('itemsTableBody') itemsTableBody: ElementRef;

    id: number;
    documentType: DocumentType = null;
    document = new Document;

    totalPaid: string;

    vats: Vat[];

    documentCompanies: DocumentCompany[];
    searchedCustomers: Customer[] = [];
    searchedContracts: Contract[] = [];
    paymentTypes: any;

    searchedProducts: any;

    saveing: boolean = false;
    sourceDocumentId: number = null;
    sourceLiquidation: DocumentLiquidation = null;
    canLoadNextNumber: boolean = false;
    documentCurrency: DocumentCurrency[];

    form: any = {
        fullNumber: new FormControl('', [
            Validators.required,
        ]),
        variableSymbol: new FormControl('', [
            Validators.required,
        ]),
        clientName: new FormControl('', [
            Validators.required,
        ]),
        clientCompanyNumber: new FormControl('', [
        ]),
        description: new FormControl('', [
        ]),
        clientVatNumber: new FormControl('', [
        ]),
        clientStreet: new FormControl('', [
            Validators.required,
        ]),
        clientCity: new FormControl('', [
            Validators.required,
        ]),
        clientZip: new FormControl('', [
            Validators.required,
        ]),
        issueDate: new FormControl('', [
            Validators.required,
        ]),
        taxDate: new FormControl('', [
            Validators.required,
        ]),
        dueDate: new FormControl('', [
            Validators.required,
        ]),
        paymentDate: new FormControl('', [
        ]),
        orderNumber: new FormControl('', [
        ]),
        orderDate: new FormControl('', [
        ]),
    };

    printService = new PrintService();

    edit: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private productService: ProductService,
        private snackService: SnackService,
        private customerService: CustomerService,
        private paymentTypeService: PaymentTypeService,
        private contractService: ContractService,
        private vatService: VatService,
        private contractItemService: ContractItemService,
        private documentLinkService: DocumentLinkService,
        private documentService: DocumentService,
        private documentLiquidationService: DocumentLiquidationService,
        private documentTypeService: DocumentTypeService,
        private documentCompanyService: DocumentCompanyService,
        private dialogService: DialogService,
        private documentCurrencyService: DocumentCurrencyService,
        private dragulaService: DragulaService,
    ) {
        this.initDragulaItems();
    }

    ngOnInit(): void {
        this.id = Number(this.route.snapshot.paramMap.get('id'));
        const documentType = this.route.snapshot.paramMap.get('type');
        const contractId = this.route.snapshot.paramMap.get('contractId');
        const documentId = this.route.snapshot.paramMap.get('documentId');
        const liquidationId = this.route.snapshot.paramMap.get('liquidationId');

        if (this.id) {
            this.loadDocument();
        } else {
            this.edit = true;
            this.loadCurrency();
            this.loadDefaultDocument(documentType, contractId, documentId, liquidationId);
            this.loadSelectsVariants();
            this.loadDocumentType(documentType, true);
        }
    };

    ngOnDestroy(): void {
        if (this.customerSearchSubscription) {
            this.customerSearchSubscription.unsubscribe();
        }
        if (this.productSearchSubscription) {
            this.productSearchSubscription.unsubscribe();
        }
        if (this.contractSearchSubscription) {
            this.contractSearchSubscription.unsubscribe();
        }
        if (this.dragulaService.find('document-items-list') !== undefined) {
            this.dragulaService.destroy('document-items-list');
        }
    };

    selectCustomer(customer: Customer) {
        this.document.customer = customer;
        this.copyCustomerInvoiceInformation();
        this.isValid();
    }

    selectContract(contract: Contract) {
        this.document.contract = contract;
    }

    getPrice(documentItem: DocumentItem, vat: boolean = false){
        if (!documentItem || !documentItem.vat) {
            return 0;
        }
        let unitPriceWithoutVat: number;
        if (documentItem.with_vat) {
            unitPriceWithoutVat = documentItem.unitPrice / (1 + (documentItem.vat.rate / 100));
        } else {
            unitPriceWithoutVat = documentItem.unitPrice;
        }
        let price = unitPriceWithoutVat * documentItem.count;
        price = price - (price * (documentItem.discount / 100));
        if (vat) {
            price = price + (price * (documentItem.vat.rate / 100));
        }
        return price;
    }

    private toCents(value: number): number {
        if (!value || !isFinite(value)) {
            return 0;
        }
        // minimalizace floating-point chyb (např. 0.1 + 0.2)
        return Math.round((value + Number.EPSILON) * 100);
    }

    /**
     * Převede ceny před uložením - pokud je with_vat = true, odečte DPH (uložíme bez DPH)
     */
    private convertPricesForSave() {
        if (!this.document || !this.document.items) {
            return;
        }
        this.document.items.forEach(item => {
            if (item.itemType === 'text' || item.itemType === 'rounding' || !item.vat) {
                return;
            }
            if (item.with_vat) {
                item.unitPrice = item.unitPrice / (1 + (item.vat.rate / 100));
            }
            item.unitPrice = parseFloat(item.unitPrice.toFixed(3));
        });
    }

    /**
     * Převede ceny po načtení - pokud je with_vat = true, přičte DPH (pro zobrazení)
     */
    private convertPricesForDisplay() {
        if (!this.document || !this.document.items) {
            return;
        }
        this.document.items.forEach(item => {
            if (item.itemType === 'text' || item.itemType === 'rounding' || !item.vat) {
                return;
            }
            if (item.with_vat) {
                item.unitPrice = item.unitPrice * (1 + (item.vat.rate / 100));
            }            
            item.unitPrice = parseFloat(item.unitPrice.toFixed(2));
        });
    }

    getTotalPrice(vat: boolean = false) {
        let totalCents = 0;
        this.document.items.forEach(item => {
            totalCents += this.toCents(this.getPrice(item, vat));
        });
        return totalCents / 100;
    }

    private getTotalPricePrecise(vat: boolean = false) {
        let total = 0;
        this.document.items.forEach(item => {
            total += this.getPrice(item, vat);
        });
        return parseFloat(total.toFixed(3));
    }


    addDocumentLiquidation() {
        const defaultAmount = this.getTotalPrice(true)-this.document.totalPaid;
        this.dialogService.showDialog(DocumentLiquidationsDialogComponent, { document: this.document, action: 'add', defaultAmount: defaultAmount }).afterClosed().subscribe((changeTotalPaid: number) => {
            if (changeTotalPaid) {
                this.document.totalPaid += changeTotalPaid;
                if (this.document.totalPaid >= this.getTotalPrice(true) && !this.document.paymentDate) {
                    this.document.paymentDate = new Date();
                }
            }
        });
    }

    showDocumentLiquidations() {
        this.dialogService.showDialog(DocumentLiquidationsDialogComponent, { document: this.document, action: 'list' }, 600).afterClosed().subscribe((changeTotalPaid: number) => {
            if (changeTotalPaid) {
                this.document.totalPaid += changeTotalPaid;
            }
        });
    }

    copyCustomerInvoiceInformation() {
        this.document.clientName = this.document.customer.invoiceName;
        this.document.clientCompanyNumber = this.document.customer.invoiceCompanyNumber;
        this.document.clientVatNumber = this.document.customer.invoiceVatNumber;
        this.document.clientStreet = this.document.customer.invoiceStreet;
        this.document.clientCity = this.document.customer.invoiceCity;
        this.document.clientZip = this.document.customer.invoiceZip;
    }

    searchAres(): void {
        if (!this.document.customer || !this.document.customer.invoiceCompanyNumber) {
            this.snackService.showWarn('Zákazník nemá vyplněné IČ.');
            return;
        }
        this.dialogService.showDialog(CustomerAresComparisonDialogComponent, {
            customer: this.document.customer
        }, 800, 'auto').afterClosed().subscribe((updatedCustomer: Customer) => {
            if (updatedCustomer) {
                this.copyCustomerInvoiceInformation();
                this.save();
            }
        });
    }

    save() {
        this.saveing = true;
        this.document.items.forEach(item => {
            if (item.fake == true) {
                const index = this.document.items.indexOf(item);
                if (index >= 0) {
                    this.document.items.splice(index, 1);
                }
            }
        });
        this.convertPricesForSave();
        console.log(this.document.items);

        if (!this.id) {
            // create
            if (this.sourceLiquidation) {
                this.document.documentLiquidation = this.sourceLiquidation;
            }
            this.documentService.save(this.document).subscribe((d: Document) => {
                this.snackService.showSuccess(`Doklad č. ${this.document.fullNumber} byl vytvořen.`);
                this.saveing = false;
                this.edit = false;
                this.id = d.id;
                this.router.navigate([`/documents/edit/${d.id}`]);

                if (this.sourceDocumentId) {
                    this.createDocumentLink(d.id, this.sourceDocumentId);
                    this.sourceDocumentId = null;
                }
                this.loadDocument();
            }, (e) => {
                this.convertPricesForDisplay();
                this.snackService.showWarn(e.error.message);
                this.saveing = false;
                this.edit = true;
            });
        } else {
            // update
            this.documentService.update(this.document.id, this.document).subscribe((d: Document) => {
                this.snackService.showSuccess(`Doklad č. ${this.document.fullNumber} byl uložen.`);
                this.loadDocument();
                this.edit = false;
                this.saveing = false;
            }, (e) => {
                this.convertPricesForDisplay();
                this.snackService.showWarn(e.error.message);
                this.saveing = false;
                this.edit = true;
            });
        }
    }

    addItem(product: Product|null = null, text: boolean = false) {
        const item = new DocumentItem();
        if (product) {
            item.product = product;
            item.text = product.name;
            item.unitPrice = product.hirePrice;
            item.count = 1;
            if (product.vat !== undefined && product.vat !== null) {
                item.vat = this.vats.find(v => v.rate === product.vat);
            }
        }
        if (text) {
            item.count = 0;
            item.text = 'Vlastní textová položka';
            item.unitPrice = 0;
            item.itemType = 'text';
            item.vat = this.vats.find(v => v.rate == 0);
        }
        if (!item.vat) {
            item.vat = this.vats.find(v => v.rate === 21);
        }
        if (this.document.documentType && this.document.documentType.slug === DOCUMENT_TYPE.RECEIVABLE && this.vats && this.vats.length > 0) {
            const zeroVat = this.vats.find(v => v.rate === 0);
            if (zeroVat) {
                item.vat = zeroVat;
            }
        }
        item.position = this.getMaxPositionNumber() + 1;
        this.document.items.push(item);
    }

    addProduct(p: Product) {
        if (this.productSearchElement) {
            this.productSearchElement.nativeElement.value = '';
        }
        this.searchedProducts = [];
        this.addItem(p);

    }

    removeItem(item) {
        const index = this.document.items.indexOf(item);
        if (index >= 0) {
            this.document.items.splice(index, 1);
        }
    }

    copyItem(item) {
        if (item.itemType === 'rounding') {
            return;
        }
        const newItem = new DocumentItem();
        newItem.product = item.product;
        newItem.vat = item.vat;
        newItem.text = item.text;
        newItem.unitPrice = item.unitPrice;
        newItem.itemType = item.itemType;
        newItem.count = item.count;
        newItem.discount = item.discount;
        newItem.position = this.getMaxPositionNumber() + 1;
        newItem.with_vat = item.with_vat;
        this.document.items.push(newItem);
    }

    mergeItems() {
        if (!this.document.items || this.document.items.length === 0) {
            return;
        }
        // položky pro jedlotilivé DPH
        const mergedItems: DocumentItem[] = [];

        // podle DPH
        const itemsByVat = {};
        this.document.items.forEach(item => {
            if (item.fake == true || item.itemType === 'rounding') {
                mergedItems.push(item);
            }
            else {
                const vatRate = item.vat.rate;
                if (!itemsByVat[vatRate]) {
                    itemsByVat[vatRate] = {
                        vat: item.vat,
                        items: []
                    };
                }
                itemsByVat[vatRate].items.push(item);
            }
        });


        let number = 1;
        Object.keys(itemsByVat).forEach(vatRate => {
            const group = itemsByVat[vatRate];

            let totalPriceWithVat = 0;
            group.items.forEach(item => {
                totalPriceWithVat += this.getPrice(item, true);
            });

            const unitPrice = totalPriceWithVat / (1 + (group.vat.rate / 100));

            const mergedItem = new DocumentItem();
            mergedItem.text = 'Sloučené položky (' + number + ')';
            number++;
            mergedItem.unitPrice = parseFloat(unitPrice.toFixed(2));
            mergedItem.count = 1;
            mergedItem.position = number;
            mergedItem.discount = 0;
            mergedItem.vat = group.vat;
            mergedItem.product = null;

            mergedItems.push(mergedItem);
        });

        this.document.items = mergedItems;
        this.orderItems();
    }


    removeLink(link) {
        console.log(link);
        this.documentLinkService.delete(link.id).subscribe(() => {
            this.snackService.showSuccess('Vazba byla odstraněna.');
            const index = this.document.links.indexOf(link);
            if (index >= 0) {
                this.document.links.splice(index, 1);
            }
        });
    }

    openLinkDocumentDialog() {
        this.dialogService.showDialog(DocumentLinkDialogComponent, { document: this.document }, 1200).afterClosed().subscribe((documentLink) => {
            if (documentLink) {
                const link = {
                    linked_document_id: documentLink.id,
                    document_id: this.document.id,
                };
                this.documentLinkService.save(link).subscribe((dl: DocumentLink[]) => {
                    let data = Object.values(dl);
                    data.forEach(d => {
                        if (!d.id) {
                            const index = data.indexOf(d);
                            if (index >= 0) {
                                data.splice(index, 1);
                            }
                        }
                    });
                    console.log(data);
                    this.document.links = data;
                });
            }
        });
    }

    openProduct(product: Product) {
        window.open(`/product/${product.id}`, '_blank');
    }

    sendToPohoda() {
        this.dialogService.showDialog(DocumentPohodaDialogComponent, {
            'document': this.document
        }).afterClosed().subscribe((result: any) => {
            if (result) {
                this.loadDocument();
                if (this.logsComponent) {
                    this.logsComponent.reloadPage();
                }
            }
        });
    }

    // --- PRIVATE METHODS ---
    private loadDocument() {
        this.documentService.get(this.id, {expand: 'items,totalPaid,documentCompany,documentCompanyAccount,documentType,customer,paymentType,links,contract,proformaInformation,documentCurrency'}).subscribe((d: Document) => {
            this.documentCurrency = [d.documentCurrency];
            this.document = d;
            this.loadSelectsVariants();
            this.loadDocumentType(this.document.documentType.slug);

            if (d.proformaInformation !== null && this.document.documentType.slug === DOCUMENT_TYPE.INVOICE) {
                if (d.proformaInformation.length > 0) {
                    d.proformaInformation.forEach((item: DocumentItem) => {
                        item.fake = true;
                        this.document.items.push(item);
                    });
                    this.syncDocumentItemsVat();
                }
            }
            this.convertPricesForDisplay();
            this.orderItems();
        });
    }

    private initCustomerSearchListener() {
        if (!this.customerSearchElement) {
            return;
        }
        if (this.customerSearchSubscription) {
            this.customerSearchSubscription.unsubscribe();
        }
        this.customerSearchSubscription = Observable.fromEvent(this.customerSearchElement.nativeElement, 'keyup')
            .debounceTime(300)
            .distinctUntilChanged()
            .subscribe(() => {
                const searchValue = this.customerSearchElement.nativeElement.value.trim();
                this.customerService.getSimpleList([
                    new Filter('search', searchValue)
                ]).subscribe((data: Customer[]) => {
                    this.searchedCustomers = data;
                });
            });
    }

    createCustomer(): void {
        this.dialogService.showDialog(CustomerCreateDialogComponent, {}, 800).afterClosed().subscribe((customer: Customer) => {
            if (customer) {
                this.selectCustomer(customer);
            }
        });
    }

    private initProductSearchListener() {
        if (!this.productSearchElement) {
            return;
        }
        if (this.productSearchSubscription) {
            this.productSearchSubscription.unsubscribe();
        }
        this.productSearchSubscription = Observable.fromEvent(this.productSearchElement.nativeElement, 'keyup')
            .debounceTime(300)
            .distinctUntilChanged()
            .subscribe(() => {
                this.productService.getSimpleList([
                    new Filter('name', '*' + this.productSearchElement.nativeElement.value.trim() + '*')
                ], {expand: 'content'}).subscribe((data: Product[]) => {
                    this.searchedProducts = data;
                });
            });
    }

    private initContractSearchListener() {
        if (!this.contractSearchElement) {
            return;
        }
        if (this.contractSearchSubscription) {
            this.contractSearchSubscription.unsubscribe();
        }
        this.contractSearchSubscription = Observable.fromEvent(this.contractSearchElement.nativeElement, 'keyup')
            .debounceTime(300)
            .distinctUntilChanged()
            .subscribe(() => {
                this.contractService.getSimpleList([
                    new Filter('search', this.contractSearchElement.nativeElement.value.trim())
                ], {expand: 'customer'}).subscribe((data: Contract[]) => {
                    this.searchedContracts = data;
                });
            });
    }

    private loadSelectsVariants() {
        this.loadDocumentCompanies();
        this.loadPaymentTypes();
        this.loadVats();
    }


    private loadDocumentType(documentTypeSlug: string, nextNumber: boolean = false) {
        let expand = '';
        if (nextNumber) {
            expand = 'nextNumber';
            this.canLoadNextNumber = true;
        }
        this.documentTypeService.getSimpleList([new Filter('slug', documentTypeSlug)], {expand: expand }).subscribe((data: DocumentType[]) => {
            this.documentType = data[0];
            this.document.documentType = this.documentType;
            if (nextNumber) {
                this.tryLoadNextNumber();
            }
        });
    }

    loadNextNumber() {
        if (!this.documentType || !this.documentType.nextNumber) {
            return;
        }
        if (!this.document.documentCompany || !this.document.documentCompany.id) {
            return;
        }
        if (!this.documentCompanies || this.documentCompanies.length === 0) {
            return;
        }

        const documentCompany = this.documentCompanies.find(c => c.id == this.document.documentCompany.id);
        if (!documentCompany || !documentCompany['accounts'] || documentCompany['accounts'].length === 0) {
            return;
        }

        const nextNumberValue = this.documentType.nextNumber[this.document.documentCompany.id];
        if (!nextNumberValue) {
            return;
        }

        this.document.documentCompanyAccount = documentCompany['accounts'][0];
        this.document.fullNumber = nextNumberValue;
        this.document.variableSymbol = nextNumberValue.replace(this.documentType.numberPrefix, '');
    }

    private tryLoadNextNumber() {
        if (this.canLoadNextNumber && this.documentType && this.documentType.nextNumber &&
            this.document.documentCompany && this.document.documentCompany.id &&
            this.documentCompanies && this.documentCompanies.length > 0) {
            this.loadNextNumber();
            this.canLoadNextNumber = false;
        }
    }

    canBeMerged(): boolean {
        const productItems = this.document.items.filter(item => item.itemType === 'product');
        let allTrue = true;
        let allFalse = true;
        productItems.forEach(item => {
            if (item.with_vat) {
                allFalse = false;
            }
            if (!item.with_vat) {
                allTrue = false;
            }
        });
        return allTrue || allFalse;
    }

    hasDecimalTotalWithVat(): boolean {
        if (!this.document.items || this.document.items.length === 0) {
            return false;
        }
        const hasRoundingItem = this.document.items.some(item => item.itemType === 'rounding');
        if (hasRoundingItem) {
            return false;
        }
        const totalWithVat = this.getTotalPricePrecise(true);
        return Math.abs(totalWithVat - Math.round(totalWithVat)) >= 0.005;
    }

    addRoundingItem() {
        if (!this.hasDecimalTotalWithVat()) {
            return;
        }
        const totalWithVat = this.getTotalPricePrecise(true);
        const roundingDiff = Math.round(totalWithVat) - totalWithVat;
        const vatZero = this.vats.find(v => v.rate === 0);
        const roundingItem = new DocumentItem();
        roundingItem.text = 'Zaokrouhlení';
        roundingItem.count = 1;
        roundingItem.discount = 0;
        roundingItem.vat = vatZero || this.vats[0];
        roundingItem.unitPrice = vatZero
            ? parseFloat(roundingDiff.toFixed(2))
            : parseFloat((roundingDiff / (1 + roundingItem.vat.rate / 100)).toFixed(2));
        roundingItem.position = this.getMaxPositionNumber() + 1;
        roundingItem.itemType = 'rounding';
        roundingItem.product = null;
        roundingItem.with_vat = false;
        this.document.items.push(roundingItem);
        this.orderItems();
    }

    private loadDefaultDocument(documentType: string, contractId = null, documentId = null, liquidationId = null) {
        const today = new Date();
        const today2 = new Date();
        const next14days = new Date(today2.setDate(today2.getDate() + 14));
        this.document.issueDate = today;
        this.document.dueDate = next14days;
        this.document.taxDate = next14days;

        this.totalPaid = "0 Kč";
        if (documentType === DOCUMENT_TYPE.RECEIVED_PAYMENT) {
            this.document.description = 'Půjčovna inventáře a mobiliáře';
        } else {
            this.document.description = 'Půjčovna inventáře a mobiliáře';
        }

        if (liquidationId) {
            this.documentLiquidationService.get(liquidationId, {expand: 'document'}).subscribe((documentLiquidation: DocumentLiquidation) => {
                this.sourceLiquidation = documentLiquidation;
                this.loadDocumentByCopy(documentLiquidation.document.id, documentType);
                return;
            });
        }

        if (contractId) {
            this.loadDocumentByContract(contractId);
            return;
        }
        if (documentId) {
            this.loadDocumentByCopy(documentId, documentType);
            return;
        }
    }

    private loadDocumentByContract(contractId) {
        this.contractService.get(contractId, {expand: 'customer,event'}).subscribe((contract: Contract) => {
           this.loadDocumentItemsByContract(contract);
           this.document.contract = contract;
           // this.document.description += ' ze zápůjčky č. ' + contract.id;
           this.document.customer = contract.customer;
           this.copyCustomerInvoiceInformation();
           this.setPaymentTypeFromContract(contract);
        });
    }

    private setPaymentTypeFromContract(contract: Contract) {
        if (!contract || !contract.paymentType) {
            return;
        }
        if (this.paymentTypes && this.paymentTypes.length > 0) {
            const matchingPaymentType = this.paymentTypes.find((pt: PaymentTypeEntity) =>
                pt.name === contract.paymentType
            );
            if (matchingPaymentType) {
                this.document.paymentType = matchingPaymentType;
            }
        }
    }

    private loadDocumentItemsByContract(contract: Contract) {
            this.contractItemService.getSimpleList(
                [new Filter('contract_id', contract.id)],
                {order: 'order', expand: 'dispatched,returned,lost,product'})
                .subscribe((items: any) => {
                    const isLossOverLimit = this.isLossOverLimitForDocument(items, contract);
                    let position = 1;
                    items.forEach(item => {
                        const i = new DocumentItem();
                        i.text = item.name;
                        if (item.isLoss) {
                            i.unitPrice = item.lossPrice || 0;
                            i.count = item.lentCount;
                            i.discount = item.sale || 0;
                        }
                        else if (item.isSell) {
                            i.unitPrice = item.hirePrice || 0;
                            i.count = item.lentCount;
                            i.discount = item.sale || 0;
                        }
                        else if (item.type === ContractItemType.delivery || item.type === ContractItemType.deployment) {
                            i.unitPrice = item.hirePrice || 0;
                            i.count = item.lentCount;
                            i.discount = item.sale || 0;
                        }
                        else {
                            const effectiveDays = item.daysChanged ? item.days : contract.daysCount;
                            i.unitPrice = item.hirePrice * effectiveDays;
                            i.count = item.lentCount;
                            i.discount = item.sale;
                        }
                        i.product = item.product;
                        i.vat = this.vats.find(v => v.rate === item.vat);
                        i.position = position;

                        this.document.items.push(i);
                        position++;

                        const lostCount = this.getLostCount(item);
                        if (contract.state === ContractState.returned && isLossOverLimit && !item.isLoss && (item.type === ContractItemType.product || item.type === ContractItemType.other) && lostCount >= 1) {
                            const lossItem = new DocumentItem();
                            lossItem.text = 'Ztráta: ' + item.name;
                            lossItem.unitPrice = item.lossPrice || 0;
                            lossItem.count = lostCount;
                            lossItem.discount = 0;
                            lossItem.product = item.product;
                            lossItem.vat = this.vats.find(v => v.rate === item.vat);
                            lossItem.position = position;
                            this.document.items.push(lossItem);
                            position++;
                        }
                    });

                    const lossSaleBase = this.getLossSaleBaseForDocument(items, contract, isLossOverLimit);
                    if (lossSaleBase > 0) {
                        const lossSaleItem = new DocumentItem();
                        lossSaleItem.text = 'Sleva na ztrátě';
                        lossSaleItem.itemType = 'product';
                        lossSaleItem.unitPrice = -Math.abs(Number(lossSaleBase));
                        lossSaleItem.count = 1;
                        lossSaleItem.discount = 0;
                        lossSaleItem.vat = this.vats.find(v => v.rate === 21) || this.vats[0];
                        lossSaleItem.position = position;
                        this.document.items.push(lossSaleItem);
                        position++;
                    }

                    if (contract.sale != null && contract.sale !== 0) {
                        const saleItem = new DocumentItem();
                        saleItem.text = 'Sleva';
                        saleItem.itemType = 'product';
                        saleItem.unitPrice = -Math.abs(Number(contract.sale));
                        saleItem.count = 1;
                        saleItem.discount = 0;
                        saleItem.vat = this.vats.find(v => v.rate === 0);
                        saleItem.position = position;
                        this.document.items.push(saleItem);
                    }
                });
    }

    private isLossOverLimitForDocument(items: any[], contract: Contract): boolean {
        let totalContractPrice = 0;
        let totalLossPrice = 0;

        items.forEach(item => {
            const count = Number(item.count) || 0;
            const discount = (Number(item.sale) || 0) / 100;
            const unitLossPrice = Number(item.lossPrice) || 0;
            const unitHirePrice = Number(item.hirePrice) || 0;
            const lostCount = this.getLostCount(item);

            if (!item.isLoss) {
                totalLossPrice += unitLossPrice * lostCount;
            }

            if (item.isWrap || item.isLoss) {
                return;
            }

            if (item.type === ContractItemType.delivery || item.type === ContractItemType.deployment || item.isSell) {
                totalContractPrice += unitHirePrice * count * (1 - discount);
                return;
            }

            const effectiveDays = item.daysChanged ? Number(item.days) || 0 : Number(contract.daysCount) || 0;
            totalContractPrice += unitHirePrice * effectiveDays * count * (1 - discount);
        });

        return totalLossPrice >= totalContractPrice * 0.01;
    }

    private getLossSaleBaseForDocument(items: any[], contract: Contract, isLossOverLimit: boolean): number {
        if (contract.state !== ContractState.returned || !isLossOverLimit || !contract.lossSale) {
            return 0;
        }

        let totalRentItemsOnlyBase = 0;
        let totalLossNonWrapBase = 0;

        items.forEach(item => {
            const count = Number(item.count) || 0;
            const discount = (Number(item.sale) || 0) / 100;
            const unitLossPrice = Number(item.lossPrice) || 0;
            const unitHirePrice = Number(item.hirePrice) || 0;
            const lostCount = this.getLostCount(item);

            const isService = item.type === ContractItemType.delivery || item.type === ContractItemType.deployment;

            if (!isService && !item.isLoss && !item.isWrap) {
                totalLossNonWrapBase += unitLossPrice * lostCount;
            }

            if (isService || item.isWrap || item.isLoss) {
                return;
            }

            if (item.isSell) {
                totalRentItemsOnlyBase += unitHirePrice * count * (1 - discount);
                return;
            }

            const effectiveDays = item.daysChanged ? Number(item.days) || 0 : Number(contract.daysCount) || 0;
            totalRentItemsOnlyBase += unitHirePrice * effectiveDays * count * (1 - discount);
        });

        return Math.min(totalRentItemsOnlyBase * 0.02, totalLossNonWrapBase);
    }

    private getLostCount(item: any): number {
        let result = typeof item.lost === 'number' ? item.lost : (item.dispatched || 0) - (item.returned || 0);
        if (result < 0) {
            result = 0;
        }
        return result;
    }

    private loadPaymentTypes() {
        this.paymentTypeService.getSimpleList([new Filter('visible', '1')]).subscribe((data: PaymentTypeEntity[]) => {
            this.paymentTypes = data;
            if (!this.id) {
                // dokument vytváříme ze zakázky - nastavení způsobu platby
                if (this.document.contract && this.document.contract.paymentType) {
                    const matchingPaymentType = this.paymentTypes.find((pt: PaymentTypeEntity) =>
                        pt.name === this.document.contract.paymentType
                    );
                    if (matchingPaymentType) {
                        this.document.paymentType = matchingPaymentType;
                    } else {
                        this.document.paymentType = this.paymentTypes[0];
                    }
                } else {
                    this.document.paymentType = this.paymentTypes[0];
                }
            }
        });
    }

    private loadVats() {
        this.vatService.getSimpleList([]).subscribe((data: Vat[]) => {
            this.vats = data;
            this.syncDocumentItemsVat();
        });
    }

    private syncDocumentItemsVat() {
        if (!this.document || !this.document.items || !this.vats) {
            return;
        }
        this.document.items.forEach(item => {
            if (!item.vat) {
                return;
            }
            const matchedVat = this.vats.find(v => {
                if (item.vat.id && v.id) {
                    return v.id === item.vat.id;
                }
                return typeof item.vat.rate !== 'undefined' && v.rate === item.vat.rate;
            });
            if (matchedVat) {
                item.vat = matchedVat;
            }
        });
    }

    private loadDocumentCompanies() {
        this.documentCompanyService.getSimpleList([], {expand: 'accounts'}).subscribe((data: DocumentCompany[]) => {
            this.documentCompanies = data;
            if (data && data.length > 0) {
                if (this.document.documentCompany && this.document.documentCompany.id) {
                    const existingCompany = data.find(c => c.id === this.document.documentCompany.id);
                    if (existingCompany) {
                        this.document.documentCompany = existingCompany;

                        if (this.document.documentCompanyAccount && this.document.documentCompanyAccount.id) {
                            const existingAccount = existingCompany.accounts.find(a => a.id === this.document.documentCompanyAccount.id);
                            if (existingAccount) {
                                this.document.documentCompanyAccount = existingAccount;
                            } else if (existingCompany.accounts && existingCompany.accounts.length > 0) {
                                this.document.documentCompanyAccount = existingCompany.accounts[0];
                            }
                        } else if (existingCompany.accounts && existingCompany.accounts.length > 0) {
                            this.document.documentCompanyAccount = existingCompany.accounts[0];
                        }
                    } else {
                        this.document.documentCompany = data[0];
                        if (data[0]['accounts'] && data[0]['accounts'].length > 0) {
                            this.document.documentCompanyAccount = data[0]['accounts'][0];
                        }
                    }
                } else {
                    this.document.documentCompany = data[0];
                    if (data[0]['accounts'] && data[0]['accounts'].length > 0) {
                        this.document.documentCompanyAccount = data[0]['accounts'][0];
                    }
                }
            }
            this.tryLoadNextNumber();
        });
    }

    isValid(): boolean {
        for (let key in this.form) {
            if (this.form[key].invalid) {
                return false;
            }
        }
        return true;
    }

    openPrint(lang: string): void {
        window.open(this.printService.getDocumentPrintUrl(this.id, lang), '_blank');
    }

    sendEmail(): void {
        this.dialogService.showDialog(DocumentMailDialogComponent, {
            document: this.document
        }, 800, 900).afterClosed().subscribe((result) => {
            if (result) {
                this.snackService.showSuccess('Email byl úspěšně odeslán.');
            }
        });
    }

    copyDocument() {
        this.dialogService.showDialog(DocumentCreateDialogComponent, { document: this.document }).afterClosed().subscribe((r) => { console.log(r); });
    }

    private loadDocumentByCopy(documentId: any, documentType = null) {
        // id původní pro vytvoření vazby
        this.sourceDocumentId = Number(documentId);

        this.documentService.get(documentId, {expand: 'items,totalPaid,documentCompany,documentCompanyAccount,documentType,customer,paymentType,contract,proformaInformation'}).subscribe((sourceDocument: Document) => {
            this.vatService.getSimpleList([]).subscribe((vats: Vat[]) => {
                this.paymentTypeService.getSimpleList([new Filter('visible', '1')]).subscribe((paymentTypes: PaymentTypeEntity[]) => {
                    this.vats = vats;
                    this.paymentTypes = paymentTypes;


                    if (documentType === DOCUMENT_TYPE.RECEIVED_PAYMENT) {
                        this.document.description = 'Daňový doklad o přijaté platbě k dokladu č. ' + sourceDocument.fullNumber;
                    }

                    if (
                        sourceDocument.proformaInformation !== null
                        && sourceDocument.documentType.slug === DOCUMENT_TYPE.PREFORMA
                        && documentType === DOCUMENT_TYPE.INVOICE
                    ) {
                        if (sourceDocument.proformaInformation.length > 0) {
                            sourceDocument.proformaInformation.forEach((item: DocumentItem) => {
                                item.fake = true;
                                this.document.items.push(item);
                            });
                            this.syncDocumentItemsVat();
                        }
                    }

                    if (sourceDocument.customer) {
                        this.document.customer = sourceDocument.customer;
                        this.copyCustomerInvoiceInformation();
                    }

                    if (sourceDocument.paymentType && paymentTypes && paymentTypes.length > 0) {
                        const matchingPaymentType = paymentTypes.find((pt: PaymentTypeEntity) =>
                            pt.id === sourceDocument.paymentType.id
                        );
                        if (matchingPaymentType) {
                            this.document.paymentType = matchingPaymentType;
                        } else if (paymentTypes.length > 0) {
                            this.document.paymentType = paymentTypes[0];
                        }
                    }

                    this.document.contract = sourceDocument.contract;
                    this.document.clientName = sourceDocument.clientName;
                    this.document.clientCompanyNumber = sourceDocument.clientCompanyNumber;
                    this.document.clientVatNumber = sourceDocument.clientVatNumber;
                    this.document.clientStreet = sourceDocument.clientStreet;
                    this.document.clientCity = sourceDocument.clientCity;
                    this.document.clientZip = sourceDocument.clientZip;
                    // this.document.description = sourceDocument.description;
                    this.document.issueDate = new Date(sourceDocument.issueDate);
                    this.document.taxDate = new Date(sourceDocument.taxDate);
                    this.document.dueDate = new Date(sourceDocument.dueDate);
                    this.document.orderNumber = sourceDocument.orderNumber;
                    this.document.orderDate = sourceDocument.orderDate ? new Date(sourceDocument.orderDate) : null;


                    if (sourceDocument.items && sourceDocument.items.length > 0) {
                        sourceDocument.items.forEach(sourceItem => {
                            const newItem = new DocumentItem();
                            newItem.product = sourceItem.product;
                            newItem.text = sourceItem.text;
                            newItem.unitPrice = sourceItem.unitPrice;
                            newItem.count = sourceItem.count;
                            newItem.discount = sourceItem.discount;
                            newItem.position = sourceItem.position;
                            newItem.with_vat = sourceItem.with_vat;

                            if (sourceItem.vat && vats && vats.length > 0) {
                                const matchedVat = vats.find(v => {
                                    if (sourceItem.vat.id && v.id) {
                                        return v.id === sourceItem.vat.id;
                                    }
                                    return typeof sourceItem.vat.rate !== 'undefined' && v.rate === sourceItem.vat.rate;
                                });
                                if (matchedVat) {
                                    newItem.vat = matchedVat;
                                } else {
                                    newItem.vat = vats.find(v => v.rate === 21) || vats[0];
                                }
                            }
                            this.document.items.push(newItem);
                        });
                    }

                    this.orderItems();

                    this.document.totalPaid = 0;
                    this.totalPaid = "0 Kč";
                    this.convertPricesForDisplay();
                });
            });
        });
    }

    private createDocumentLink(newDocumentId: number, sourceDocumentId: number) {
        const link = {
            linked_document_id: sourceDocumentId,
            document_id: newDocumentId,
        };
        this.documentLinkService.save(link).subscribe((dl: DocumentLink[]) => {
            this.snackService.showSuccess('Vazba k původnímu dokumentu byla vytvořena.');
            if (this.id === newDocumentId) {
                this.loadDocument();
            }
        }, (e) => {
            this.snackService.showWarn('Nepodařilo se vytvořit vazbu k původnímu dokumentu.');
        });
    }

    private orderItems() {
        this.document.items.forEach(item => {
            item.unitPrice = parseFloat(item.unitPrice.toFixed(2));
        });
        this.document.items.sort((a, b) => a.position - b.position);
    }

    initDragulaItems(): void {
        if (this.dragulaService.find('document-items-list') !== undefined) {
            this.dragulaService.destroy('document-items-list');
        }
        this.dragulaService.setOptions('document-items-list', {
            moves: (el, container, handle) => {
                if (handle.className !== 'handle') {
                    return false;
                }
                const itemId = +el.dataset.itemId;
                return !isNaN(itemId) && itemId > 0;
            }
        });
        this.dragulaService.drag.subscribe((val) => {
            if (val[0] === 'document-items-list') {
                val[1].classList.add('dragging');
            }
        });
        this.dragulaService.drop.subscribe((val) => {
            if (val[0] === 'document-items-list') {
                val[1].classList.remove('dragging');
                this.saveNewItemsOrder();
            }
        });
    }

    saveNewItemsOrder(): void {
        if (!this.itemsTableBody || !this.itemsTableBody.nativeElement) {
            return;
        }
        let position = 1;
        for (const child of this.itemsTableBody.nativeElement.children) {
            const itemId = +child.dataset.itemId;
            if (isNaN(itemId) || itemId <= 0) {
                continue;
            }
            const item: DocumentItem = this.document.items.find(i => i.id === itemId);
            if (item && item.position !== position) {
                item.position = position;
            }
            position++;
        }
    }

    private getMaxPositionNumber(): number {
        if (!this.document || !this.document.items || this.document.items.length === 0) {
            return 0;
        }
        let max = 0;
        for (const item of this.document.items) {
            max = item.position > max ? item.position : max;
        }
        return max;
    }

    protected readonly DocumentType = DocumentType;
    protected readonly Document = Document;
    protected readonly DOCUMENT_TYPE = DOCUMENT_TYPE;
    protected readonly ITEM_TYPE_ROUNDING = 'rounding';

    isNotType(documentTypeSlug: string) {
        if (this.document.documentType) {
            return this.document.documentType.slug !== documentTypeSlug;
        }
        return false;
    }

    isEurCurrency(): boolean {
        return this.document.documentCurrency && this.document.documentCurrency.slug === 'eur';
    }

    private loadCurrency() {
        this.documentCurrencyService.getSimpleList([], {expand: ''}).subscribe((data: DocumentCurrency[]) => {
            this.documentCurrency = data;
            this.document.documentCurrency = this.documentCurrency.find(c => c.slug === 'czk');
        });
    }

    changeCurrency() {
        this.document.documentCurrency = this.document.documentCompanyAccount.currency;
    }

    unlockDocument() {
        this.document.isLocked = false;
        this.documentService.update(this.document.id, this.document).subscribe((d: Document) => {
            this.snackService.showSuccess(`Doklad č. ${this.document.fullNumber} byl odemčen.`);
            this.loadDocument();
        }, (e) => {
            this.snackService.showWarn(e.error.message || 'Nepodařilo se odemknout doklad.');
            this.document.isLocked = true;
        });
    }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentEditComponent/document-edit.component.ts